/**
 * Local cfcalls config derived from the app constants. Replaces the electron
 * feature's `../../config` import so the ported hooks stay otherwise unchanged.
 */

import {CALLS_SERVICE} from '#/lib/constants'

const service: string = CALLS_SERVICE

export const cfcallsConfig = {
  /** partytracks `prefix` -> the worker's SFU proxy. */
  sfuApiBase: `${service}/cfcalls/proxy`,
  /** WebSocket base for the per-room signaling DO. */
  roomWsBase: `${service.replace(/^http/, 'ws')}/cfcalls/room`,
  /** REST endpoint for short-lived TURN credentials. */
  turnCredentialsPath: '/cfcalls/turn-credentials',
}
